import { compose } from 'recompose';
import { withNamespaces } from 'react-i18next';
import NavigationTasks from './navigationTasks';

const enhance = compose(
  withNamespaces(['tasks']),
);
export default enhance(NavigationTasks);
